import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import Api from '../../Utils/api';
import _ from 'lodash';
import Utils from "../../Utils/Utility";
import CONFIG_HELPER from './../../../ConfigHelper';
import Actions from "../../actions";
import MainStore from '../stores/main-store';
import CustomChargesView from "../custom-charges/custom-charges-view";
import AddCharge from "../custom-charges/add-charge";
import CustomChargeStore from "../stores/custom-charge-store";

const DELIVERY = "Delivery";
const PICKUP = "PickUp";
const CURBSIDEPICKUP = "CurbsidePickUp";
const DINEIN = "DineIn";

export default class AllCharges extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            activeLocation: null,
            bizId: null,
            isLoaded: true,
            showAddChargeView: false,
            showAllCustomChargesView:true,
            // showOrdersTab: true,
            defaultChargeDetail:{},
        }

        this._bind(
            'addNewChargeAction',
            'callBackParent',
            'callBackAfterUpdate',
            'reloadCustomChargesData',
            'updateChargeAction',
            'deleteChargeAction',
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {

        // when load the main class get all the data and reload
        // this.enableDeliveryView();

    }

    componentWillMount() {

        Utils.isUserSessionInvalid().then((response) => {
            // user session in valid
            this.setState({
                activeLocation : this.props.activeLocation,
                isUserSessionInvalid : true,
                bizId : this.props.bizId
            });

        }, (error) => {
            // user session is invalid
            Utils.checkErrorIsInvalidSessionToken(error, this.context.router);

        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != null) {
            this.setState({
                activeLocation : nextProps.activeLocation,
                bizId : nextProps.bizId
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps != null && nextProps.isActive) {
            return true;
        } else {
            return false;
        }
    }

    // enableDeliveryView(){
    //     this.setState({
    //         isDeliveryView: true,
    //         selectedOrderTypeTab:DELIVERY,
    //         isPickUpView: false,
    //         isCurbsidePickUpView: false,
    //         isDineInView: false,
    //         // showOrdersTab: true,
    //         showAddChargeView: false,
    //         defaultChargeDetail:{}
    //     });
    // }


    addNewChargeAction(){

        this.setState({
            showAllCustomChargesView:false,
            showAddChargeView: true,
            defaultChargeDetail:{},
        });
    }

    callBackParent(){

        this.setState({
            showAllCustomChargesView:true,
            showAddChargeView: false,
            defaultChargeDetail:{}
        });

    }

    // switchTabAfterUpdate(selectedOrderTypeTab){
    //
    //
    //     let self = this;
    //     switch(selectedOrderTypeTab) {
    //         case DELIVERY:
    //             self.enableDeliveryView();
    //             break;
    //         case PICKUP:
    //             self.enablePickUpView();
    //             break;
    //         case CURBSIDEPICKUP:
    //             self.enableCurbsidePickUpView();
    //             break;
    //         case DINEIN:
    //             self.enableDineInView();
    //             break;
    //         default:
    //             self.enableDeliveryView();
    //     };
    // }



    callBackAfterUpdate(){

        // this.reloadCustomChargesData();

        let self = this;

        self.setState({
            showAllCustomChargesView:true,
            showAddChargeView: false,
            defaultChargeDetail:{}
        }, ()=>{
            // when load the main class get all the data and reload
            self.reloadCustomChargesData();
        });
    }

    updateChargeAction(chargeDetail){

        this.setState({
            showAllCustomChargesView:false,
            showAddChargeView: true,
            defaultChargeDetail:chargeDetail
        });
    }

    deleteChargeAction(chargeDetail){

        let self = this;
        let result = confirm("Are you sure you want to delete "+chargeDetail.name+"?");
        if (result) {

            //Logic to delete the charge
            let currentUser = Parse.User.current();
            let userId = currentUser.id;
            let sessionToken = currentUser.getSessionToken();
            let businessDetail = currentUser.get("bizId");
            let bizId = businessDetail.id;

            let activeLocation = this.state.activeLocation;
            let locId = activeLocation.objectId;

            let chargeConfigObject = CustomChargeStore.getCustomCharges();

            let chargeId = chargeDetail.chargeId;

            // find the charge based on the chargeId
            let chargeIndex = chargeConfigObject.findIndex(function (charge) {
                return charge.chargeId == chargeId
            });

            // if charge exist then update with latest params
            if (chargeIndex != -1){

                chargeConfigObject.splice(chargeIndex, 1);

            } else {
                // if charge is not exist then show the error message

                // let errors = {};
                alert("Charge id does not exist. Please contact to support team");

                self.setState({
                    isLoaded: true
                });
                return;
            }

            // check if the charge array lenght is 0 then set undefined object
            if (chargeConfigObject.length == 0){
                chargeConfigObject = {"__op" : "Delete"};
            }

            let paramsObject = {
                "objectId"         : locId,
                "chargeConfig"     : chargeConfigObject
            };

            self.setState({
                isLoaded : false
            });

            Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
                .then(
                    (result) => {
                        const response = result.data;
                        // console.log(JSON.stringify(response));

                        self.setState({
                            isLoaded : true
                        });

                        self.reloadCustomChargesData();

                    },
                    (error) => {
                        Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                        this.setState({isLoaded : true });
                        console.log("Error occured while fetching latest user data!");
                    }
                );
        }

    }


    reloadCustomChargesData() {

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();

        let activeLocation = this.props.activeLocation;
        let locId = activeLocation.objectId;

        let self = this;

        Api.getLocationDetail(locId, userId, sessionToken)
            .then(
                (result) => {
                    const locationDetail = result.data;

                    // load the latest custom charges
                    CustomChargeStore.onMainDataCustom(locationDetail);

                    self.setState({
                        activeLocation: locationDetail
                    })

                },
                (error) => {
                    if (error != null && error.responseJSON != null && error.responseJSON.error != null) {
                        console.log("Error occured while fetching latest user data!" + JSON.stringify(error));
                        alert(error.responseJSON.error.message);
                    }
                    // Utils.checkErrorIsInvalidSessionToken(error,this.context.router);
                    // this.setState({showSpinner : false });
                });
    }

    render() {

        return (
            <div className="order-pg">
                {!this.state.isLoaded ? <Spinner/> : null}

                <div>
                    <div className = "row">
                            <div className="col-xs-12">
                                <button className={"btn btn-primary"} onClick={this.addNewChargeAction} style={{float:"right"}}><i className="fa fa-plus" aria-hidden="true"></i> Add Charge</button>

                                <h3 id="translations" className="page-header">All Charges</h3>
                             </div>
                    </div>
                    {
                        this.state.showAllCustomChargesView ? (
                            <div>
                                <CustomChargesView
                                    activeLocation={this.props.activeLocation}
                                    callBackUpdateCharge={this.updateChargeAction}
                                    callBackDeleteCharge={this.deleteChargeAction}
                                ></CustomChargesView>
                            </div>
                        ) : null
                    }
                    {/*{*/}
                        {/*this.state.isPickUpView ? (*/}
                            {/*<div>*/}
                                {/*<PickUpCharges*/}
                                    {/*activeLocation={this.props.activeLocation}*/}
                                    {/*callBackUpdateCharge={this.updateChargeAction}*/}
                                    {/*callBackDeleteCharge={this.deleteChargeAction}*/}
                                {/*></PickUpCharges>*/}
                            {/*</div>*/}
                        {/*) : null*/}
                    {/*}*/}
                    {/*{*/}
                        {/*this.state.isCurbsidePickUpView ? (*/}
                            {/*<div>*/}
                                {/*<CurbsidePickUpCharges*/}
                                    {/*activeLocation={this.props.activeLocation}*/}
                                    {/*callBackUpdateCharge={this.updateChargeAction}*/}
                                    {/*callBackDeleteCharge={this.deleteChargeAction}*/}
                                {/*></CurbsidePickUpCharges>*/}
                            {/*</div>*/}
                        {/*) : null*/}
                    {/*}*/}
                    {/*{*/}
                        {/*this.state.isDineInView ? (*/}
                            {/*<div>*/}
                                {/*<DineInCharges*/}
                                    {/*activeLocation={this.props.activeLocation}*/}
                                    {/*callBackUpdateCharge={this.updateChargeAction}*/}
                                    {/*callBackDeleteCharge={this.deleteChargeAction}*/}
                                {/*></DineInCharges>*/}
                            {/*</div>*/}
                        {/*) : null*/}
                    {/*}*/}
                    {
                        this.state.showAddChargeView ? (
                            <div>
                                <AddCharge
                                    activeLocation = {this.props.activeLocation}
                                    callBackAfterUpdate={this.callBackAfterUpdate}
                                    callBackParent={this.callBackParent}
                                    chargeDetail = {this.state.defaultChargeDetail}
                                />
                            </div>
                        ) : null
                    }
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/custom-charges/all-charges.js